"use strict";
/// <reference lib="es2015.promise" />
/// <reference lib="es2015.collection" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Render = /** @class */ (function () {
    function Render() {
        var _this = this;
        this.queue = Promise.resolve();
        this.seen = new Set();
        if (Render.instance)
            return;
        Render.instance = this;
        this.clearMessage();
        var url = new URL(window.location.href);
        var token = url.searchParams.get('lb-added') || '';
        if (token) {
            url.searchParams.delete('lb-added');
            window.history.replaceState(window.history.state, '', url.toString());
        }
        this.runRender(token);
        jQuery(document.body).on('added_to_cart.lbConfirmation', function () {
            _this.clearMessage();
            _this.runRender('', true);
        });
        jQuery(document.body).on('updated_cart_totals.lbConfirmation removed_from_cart.lbConfirmation', function () {
            _this.runRender();
        });
        document.addEventListener('submit', function (event) {
            if (event.target instanceof HTMLFormElement && event.target.matches('form.cart')) {
                _this.clearMessage();
            }
        });
        window.addEventListener('pagehide', function () { return _this.clearMessage(); });
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                _this.clearMessage();
                _this.runRender();
            }
        });
    }
    Render.prototype.runRender = function (token, afterAjax) {
        var _this = this;
        if (token === void 0) { token = ''; }
        if (afterAjax === void 0) { afterAjax = false; }
        // One request at a time: an older response cannot overtake a newer one.
        this.queue = this.queue.then(function () { return _this.fetchRender(token, afterAjax); }).catch(function (error) {
            console.error('LB basket confirmation:', error);
        });
    };
    Render.prototype.fetchRender = function (token, afterAjax) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, results;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = [{ class: '.c-header__qty', wrapper: '.c-header__qty', action: 'cart_count' }];
                        if (document.querySelector('.lb-inline-notices')) {
                            data.push({ class: '.lb-inline-notices__message', wrapper: '.lb-inline-notices',
                                action: 'woo_messages', token: token, after_ajax: afterAjax,
                                context: document.body.classList.contains('single-product') ? 'product' : 'other' });
                        }
                        return [4 /*yield*/, fetch('/api/render', {
                                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw new Error('Render HTTP ' + response.status);
                        return [4 /*yield*/, response.json()];
                    case 2:
                        results = _a.sent();
                        results.forEach(function (item) {
                            if (item.action === 'cart_count') {
                                document.querySelectorAll('.c-header__qty').forEach(function (element) {
                                    var _a;
                                    element.classList.toggle('u-hide', item.html === 'hide');
                                    element.classList.toggle('isHidden', item.html === 'hide');
                                    if (item.html !== 'hide')
                                        element.textContent = String((_a = item.html) !== null && _a !== void 0 ? _a : '');
                                });
                            }
                            else if (item.action === 'woo_messages' && item.html && item.html !== 'hide') {
                                var id = item.confirmation_id || '';
                                var duplicate = id !== '' && _this.seen.has(id);
                                try {
                                    duplicate = duplicate || (id !== '' && sessionStorage.getItem('lb-confirmation-seen') === id);
                                }
                                catch (_) { }
                                if (duplicate && !item.has_errors)
                                    return;
                                if (id) {
                                    _this.seen.add(id);
                                    try {
                                        sessionStorage.setItem('lb-confirmation-seen', id);
                                    }
                                    catch (_) { }
                                }
                                _this.clearMessage();
                                document.querySelectorAll('.lb-inline-notices').forEach(function (wrapper) {
                                    var message = wrapper.querySelector('.lb-inline-notices__message');
                                    if (!message)
                                        return;
                                    message.innerHTML = String(item.html);
                                    message.setAttribute('role', item.has_errors ? 'alert' : 'status');
                                    // Error messages remain visible and visually distinct from confirmations.
                                    if (item.has_errors)
                                        message.style.backgroundColor = '#b42318';
                                    wrapper.classList.remove('u-hide', 'isHidden');
                                });
                                if (!item.has_errors)
                                    _this.timer = window.setTimeout(function () { return _this.clearMessage(); }, 6000);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Render.prototype.clearMessage = function () {
        if (this.timer !== undefined)
            window.clearTimeout(this.timer);
        document.querySelectorAll('.lb-inline-notices').forEach(function (wrapper) {
            wrapper.classList.add('u-hide');
            var message = wrapper.querySelector('.lb-inline-notices__message');
            if (message) {
                message.innerHTML = '';
                message.style.removeProperty('background-color');
            }
        });
    };
    Render.instance = null;
    return Render;
}());
exports.default = Render;
